import { CheckIcon, PencilIcon, XMarkIcon } from '@heroicons/react/24/outline';
import React from 'react';

interface DatevBookingHeaderProps {
  entryCount: number;
  isEditing: boolean;
  hasChanges: boolean;
  onEditStart?: () => void;
  onSave?: () => void;
  onCancel?: () => void;
  onRestore?: () => void;
  exportAction?: React.ReactNode;
}

const DatevBookingHeader: React.FC<DatevBookingHeaderProps> = ({
  entryCount,
  isEditing,
  hasChanges,
  onEditStart,
  onSave,
  onCancel,
  onRestore,
  exportAction,
}) => {
  const entryLabel = entryCount === 1 ? 'entry' : 'entries';
  const canShowEditButton = Boolean(onEditStart) && !isEditing;
  const canShowSaveCancel = Boolean(onSave) && Boolean(onCancel) && isEditing;

  return (
    <div className='mb-3 flex justify-between items-center'>
      <h3 className='text-lg font-semibold text-gray-900'>
        DATEV Booking Data ({entryCount} {entryLabel})
      </h3>
      <div className='flex items-center gap-2'>
        {exportAction}
        {canShowEditButton && (
          <button
            onClick={onEditStart}
            className='p-1 text-gray-600 hover:text-blue-600'
            title='Edit'
          >
            <PencilIcon className='w-4 h-4' />
          </button>
        )}
        {canShowSaveCancel && (
          <div className='flex gap-2'>
            <button
              onClick={onSave}
              className='text-xs px-3 py-1.5 bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1'
            >
              <CheckIcon className='w-3 h-3' />
              Save
            </button>
            <button
              onClick={onCancel}
              className='text-xs px-3 py-1.5 bg-gray-500 text-white rounded hover:bg-gray-600 flex items-center gap-1'
            >
              <XMarkIcon className='w-3 h-3' />
              Cancel
            </button>
          </div>
        )}
        {onRestore && !isEditing && hasChanges && (
          <button
            onClick={onRestore}
            className='text-xs px-2 py-1 text-gray-600 hover:text-blue-600'
            title='Restore original data'
          >
            Restore
          </button>
        )}
      </div>
    </div>
  );
};

export default DatevBookingHeader;
